var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "certificate_icon",
    "data-name": "certificate icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 31.806,
    viewBox: "0 0 38 31.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27016",
    "data-name": "Group 27016",
    transform: "translate(-375.5 -174.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27014",
    "data-name": "Group 27014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27013",
    "data-name": "Group 27013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27012",
    "data-name": "Group 27012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10613",
    "data-name": "Path 10613",
    d: "M407.25,188.9a1.25,1.25,0,0,0-1.25-1.25H385a1.25,1.25,0,0,0,0,2.5h21A1.25,1.25,0,0,0,407.25,188.9ZM385,192.653a1.25,1.25,0,0,0,0,2.5h8.7a1.25,1.25,0,1,0,0-2.5Zm14-7.5a1.25,1.25,0,0,0,0-2.5h-8a1.25,1.25,0,0,0,0,2.5ZM411.5,174.6h-34a2,2,0,0,0-2,2v25a2,2,0,0,0,2,2h19v-4h-14a3,3,0,0,0-3-3v-15a3,3,0,0,0,3-3h24a3,3,0,0,0,3,3v15a3,3,0,0,0-3,3h0v4h5a2,2,0,0,0,2-2v-25A2,2,0,0,0,411.5,174.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10614",
    "data-name": "Path 10614",
    d: "M399,201.738v4.218a.446.446,0,0,0,.448.447.441.441,0,0,0,.258-.084l1.535-1.1a.446.446,0,0,1,.259-.083.451.451,0,0,1,.26.083l1.535,1.1a.438.438,0,0,0,.257.084.446.446,0,0,0,.448-.447v-4.218a5.928,5.928,0,0,1-5,0Zm2.5-1.947a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,401.5,199.791Z",
    fill: "#fff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateIcon);
export default __webpack_public_path__ + "static/media/certificateIcon.f4116fd0e9199c17b9604d575beb5f9a.svg";
export { ForwardRef as ReactComponent };